import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions  } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ApiSettings } from '../../api.settings';

@Injectable()
export class StatsService {

  private statusURL = ApiSettings.API_URL + 'stats';
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers, withCredentials: true });

  constructor(private http: Http, private router: Router) { };

    parseParams(params: any){
        params = this.cleanEmptyParams(params);  
        let query : string = "?";
        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                if (JSON.stringify(params[key])[0] === '{'){
                    query += key +"="+ JSON.stringify(params[key])+'&';
                }else{
                    query += key +"="+ params[key]+'&';
                }
            }
        }
        if (query[query.length-1] === '&'){
            query = query.substring(0,query.length-1);
        }
        return query;
    }

    getExpensesPurchases(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getExpensesPurchases' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getExpensesRepurchases(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getExpensesRepurchases' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getExpensesExpenses(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getExpensesExpenses' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueSaleReturn(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueSaleReturn' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueSale(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueSale' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueSaleAndMethod(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueSaleAndMethod' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueWithdrawalRepurchaseTicket(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueWithdrawalRepurchaseTicket' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueWithdrawalRepurchase(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueWithdrawalRepurchase' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueRepurchaseRenewals(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueRepurchaseRenewals' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }
    getRevenueTechnicalService(params: any): Observable<any> {
        return this.http.get(this.statusURL +'/getRevenueTechnicalService' +  this.parseParams(params), this.options)
                        .map(this.extractData)
                        .catch(this.handleError.bind(this));
    }

    
    private cleanEmptyParams(params){
        if (params && params.where) {
            for (var filter in params.where) {
                if (!params.where[filter].contains && params.where[filter].contains === "") {
                    delete params.where[filter];
                }
            }
        }
        return params;
    }


    private extractData(res: Response) {
        let body = res.json();
        return body || { };
    }

    private handleError (error: Response | any) {
        if (error.status === 403){
            this.router.navigate(['/login']);
        }
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// ./src/app/reports/services/stats.service.ts